import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-scroll';

function Navbar() {
  const [isSticky, setIsSticky] = useState(false);
  const navbarRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const navbarTop = navbarRef.current.getBoundingClientRect().top;
      
      // If navbar reaches top of the viewport
      if (navbarTop <= 10) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <nav ref={navbarRef} className={`navbar main-nav ${isSticky ? 'sticky' : ''}`}>
      <div className="row justify-content-end rest">
        <div className="col-lg-8 rest">
        <a href="#0" className="logo">
              <img src="/assets/imgs/DH_logo_white.svg" alt="" />
            </a>
          <ul className="navbar-nav main-bg d-flex justify-content-end">
            <li className="nav-item">
              <a href="/dark">
                <span>Home</span>
              </a>
            </li>
            <li className="nav-item">
              <Link to="services" spy={true} smooth={true}>
                <span>Services</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link to="home" spy={true} smooth={true}>
                <span>About</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link to="portfolio" spy={true} smooth={true}>
                <span>Portfolio</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link to="price" spy={true} smooth={true}>
                <span>Price</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link to="contact" spy={true} smooth={true}>
                <span>Contact</span>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
